function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { useMemo } from "react";
import { useBuildStyleWithTheme } from "../ThemeProvider/useBuildStyleWithTheme";
import { boxShadow } from "../../utils/css/cssFor";
var positionKeyFromPlacement = function(placement) {
    return placement ? placement.split('-') : [
        'bottom'
    ];
};
export var smallCaretHeight = 6;
export var mediumCaretHeight = 10;
export var largeCaretHeight = 16;
var smallCaretBorder = Math.round(Math.sqrt(Math.pow(smallCaretHeight, 2) / 2));
var mediumCaretBorder = Math.round(Math.sqrt(Math.pow(mediumCaretHeight, 2) / 2));
var largeCaretBorder = Math.round(Math.sqrt(Math.pow(largeCaretHeight, 2) / 2));
var buildStyle = function(theme) {
    var backgroundColor = theme.backgroundColor;
    return {
        arrowContainer: {
            position: {
                top: {
                    bottom: 0
                },
                right: {
                    left: 0
                },
                bottom: {
                    top: 0
                },
                left: {
                    right: 0
                }
            }
        },
        arrow: {
            base: {
                content: '""',
                position: 'absolute',
                border: 'solid',
                borderColor: backgroundColor.base,
                transform: 'rotate(-45deg) translate(-50%, -50%)',
                transformOrigin: '0 0'
            },
            shadow: {
                top: {
                    boxShadow: '-6px 6px 6px 0px rgba(0, 0, 0, 0.04)'
                },
                right: {
                    boxShadow: '-6px -6px 6px 0px rgba(0, 0, 0, 0.04)'
                },
                bottom: {
                    boxShadow: '6px -6px 6px 0px rgba(0, 0, 0, 0.04)'
                },
                left: {
                    boxShadow: '6px 6px 6px 0px rgba(0, 0, 0, 0.04)'
                }
            },
            size: {
                small: {
                    borderWidth: smallCaretBorder
                },
                medium: {
                    borderWidth: mediumCaretBorder
                },
                large: {
                    borderWidth: largeCaretBorder
                }
            },
            position: {
                top: {
                    borderColor: "transparent transparent ".concat(backgroundColor.base, " ").concat(backgroundColor.base)
                },
                right: {
                    borderColor: "".concat(backgroundColor.base, " transparent transparent ").concat(backgroundColor.base)
                },
                bottom: {
                    borderColor: "".concat(backgroundColor.base, " ").concat(backgroundColor.base, " transparent transparent")
                },
                left: {
                    borderColor: "transparent ".concat(backgroundColor.base, " ").concat(backgroundColor.base, " transparent")
                }
            }
        },
        popper: {
            shadow: _objectSpread({}, boxShadow(3, theme)),
            zIndex: {
                zIndex: theme.depth.zIndex[100]
            }
        }
    };
};
var useStyle = function(param) {
    var _arrowSize = param.arrowSize, arrowSize = _arrowSize === void 0 ? 'medium' : _arrowSize, arrowStyles = param.arrowStyles, hasShadow = param.hasShadow, placement = param.placement, zIndex = param.zIndex;
    var ref6;
    var ref1 = (ref6 = useBuildStyleWithTheme(buildStyle)) !== null && ref6 !== void 0 ? ref6 : {}, arrow = ref1.arrow, arrowContainer = ref1.arrowContainer, popper = ref1.popper;
    var ref2 = _slicedToArray(positionKeyFromPlacement(placement), 1), position = ref2[0];
    return useMemo(function() {
        var ref, ref3, ref4, ref5;
        return {
            defaultArrowStyles: _objectSpread({}, arrowContainer === null || arrowContainer === void 0 ? void 0 : (ref = arrowContainer.position) === null || ref === void 0 ? void 0 : ref[position], {
                '&::before': _objectSpread({}, arrow === null || arrow === void 0 ? void 0 : arrow.base, hasShadow && (arrow === null || arrow === void 0 ? void 0 : (ref3 = arrow.shadow) === null || ref3 === void 0 ? void 0 : ref3[position]), arrow === null || arrow === void 0 ? void 0 : (ref4 = arrow.position) === null || ref4 === void 0 ? void 0 : ref4[position], arrow === null || arrow === void 0 ? void 0 : (ref5 = arrow.size) === null || ref5 === void 0 ? void 0 : ref5[arrowSize], arrowStyles)
            }),
            defaultPopperStyles: _objectSpread({}, hasShadow && (popper === null || popper === void 0 ? void 0 : popper.shadow)),
            popperContainerStyles: _objectSpread({}, zIndex ? {
                zIndex: zIndex
            } : popper === null || popper === void 0 ? void 0 : popper.zIndex)
        };
    }, [
        arrow,
        arrowContainer,
        arrowSize,
        arrowStyles,
        hasShadow,
        popper,
        position,
        zIndex
    ]);
};
export default useStyle;
